import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomControlsModule } from '@identic/controls';
import { DataSourceDataAccessModule } from 'data-source/data-access';
import { DataSourceGuard } from './selector.guard';
import { DataSourceSelectorComponent } from './selector.component';

const COMPONENTS = [DataSourceSelectorComponent];
const PROVIDERS = [DataSourceGuard];

@NgModule({
  imports: [
    CommonModule,
    CustomControlsModule.forRoot(),
    DataSourceDataAccessModule,
  ],
  providers: PROVIDERS,
  declarations: COMPONENTS,
  exports: COMPONENTS
})
export class DataSourceSelectorModule {}
